import React from "react";

const ProgressCards = () => {
  const cards = [
    {
      title: "CONCLUÍDO",
      description: "Equipamentos instalados conforme contrato",
      color: "bg-green-500",
      iconColor: "text-green-600",
      bgColor: "bg-green-50 dark:bg-green-900/20"
    },
    {
      title: "DISPONÍVEL",
      description: "Equipamentos disponíveis para instalação",
      color: "bg-blue-500",
      iconColor: "text-blue-600",
      bgColor: "bg-blue-50 dark:bg-blue-900/20"
    },
    {
      title: "EXCEDIDO",
      description: "Equipamentos acima do limite contratado",
      color: "bg-red-500",
      iconColor: "text-red-600",
      bgColor: "bg-red-50 dark:bg-red-900/20"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {cards.map((card, index) => (
        <div key={index} className={`${card.bgColor} rounded-xl p-4 border border-gray-200 dark:border-gray-700 transition-all duration-200 hover:shadow-md`}>
          <div className="flex items-center justify-between mb-3">
            <h3 className={`font-semibold text-sm ${card.iconColor}`}>
              {card.title}
            </h3>
            <div className={`w-3 h-3 rounded-full ${card.color}`}></div>
          </div>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            {card.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProgressCards;
